import React, { useState } from 'react';
import { Box, Container, CssBaseline, Grid, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

const PageHeading = ({ pageTitle }) => {
  const location = useLocation();
  const { t } = useTranslation();
  console.log('location', location);

  return (
    <Box className="headingBox">
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Typography variant="h1" className="homeCardHeading">
          {t(pageTitle)}
        </Typography>
      </Container>
    </Box>
  );
};

export default PageHeading;
